import React from "react";
import i18n from "i18next";

import { NonSortableHeaderCell } from "../../../../Layout/SortedList";

const SubListHeader = () => (
  <div role="row" tabIndex="0" className="sorted-list__row-header --sub">
    <NonSortableHeaderCell className="--first --x4" keyName="productName" label={i18n.t("products.product")} />
    <NonSortableHeaderCell className="--x3" keyName="dimension" label={i18n.t("products.dimensions")} />
    <NonSortableHeaderCell className="--x3" keyName="planningStatus.quantity" label={i18n.t("products.planning")} />
    <NonSortableHeaderCell className="--right --x2" keyName="productionStatus.quantity" label={i18n.t("products.produced")} />
    <NonSortableHeaderCell className="--right --x2" keyName="shipmentStatus.quantity" label={i18n.t("products.shipped")} />
    <NonSortableHeaderCell className="--x2" keyName="marks" label={i18n.t("products.marks")} />
    <NonSortableHeaderCell className="--x3" keyName="coreDescription" label={i18n.t("products.coreDescription")} />
  </div>
);

export default SubListHeader;



// WEBPACK FOOTER //
// ./src/components/PurchaseOrder/OrderPage/List/Products/SubListHeader.js